import { schema } from 'normalizr';

import { processCampaignCoverImage } from '../strategies/campaignCoverImage';

export const campaignCoverImageSchema = new schema.Entity(
  'campaignCoverImages',
  {},
  { processStrategy: processCampaignCoverImage }
);

export type CampaignCoverImageEdgesSchema = typeof campaignCoverImageSchema;
export const campaignCoverImageEdgesSchema = [new schema.Object({ node: campaignCoverImageSchema })];
